module.exports = __webpack_public_path__ + "static/media/confirmation.71a1cbe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/confirmation.png
// module id = 49
// module chunks = 0